import type { SVGProps } from 'react';

const SvgIconSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Loading spinner</title>
    <path d="M14 8C14 4.13401 10.866 1 7 1" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
);
export default SvgIconSpinner;
